import { render, staticRenderFns } from "./MagicLogin.vue?vue&type=template&id=589972de&scoped=true"
import script from "./MagicLogin.vue?vue&type=script&lang=js"
export * from "./MagicLogin.vue?vue&type=script&lang=js"
import style0 from "./MagicLogin.vue?vue&type=style&index=0&id=589972de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589972de",
  null
  
)

export default component.exports